/* GARIN size guide unit toggle — robust across Shopify section reloads */
(function(){
  function bindInScope(scope){
    if (!scope) return;
    var sw = scope.querySelector('#unit-switch');
    if (!sw || sw.dataset.bound === '1') return;

    sw.dataset.bound = '1';

    function setUnit(unit){
      sw.dataset.unit = unit; // moves knob via CSS
      sw.setAttribute('aria-checked', unit === 'cm' ? 'true' : 'false');
      scope.querySelectorAll('.mv').forEach(function(el){
        var val = el.dataset[unit]; // "in" or "cm"
        if (val != null && val !== '') el.textContent = val;
      });
      try { localStorage.setItem('garin_unit', unit); } catch(e){}
    }

    sw.addEventListener('click', function(){
      setUnit(sw.dataset.unit === 'in' ? 'cm' : 'in');
    });
    sw.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sw.click(); }
    });

    var pref = 'in';
    try { pref = localStorage.getItem('garin_unit') || sw.dataset.unit || 'in'; } catch(e){}
    setUnit(pref);
  }

  function bindAll(){ document.querySelectorAll('.garin-size').forEach(bindInScope); }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // Re-bind after dynamic loads / editor actions / history nav
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('page:load', bindAll);
  window.addEventListener('popstate', bindAll);

  // Fallback: observe DOM changes in case content is injected later
  new MutationObserver(function(){
    if (document.querySelector('.garin-size #unit-switch')) bindAll();
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
